import CheckOutlined from '@ant-design/icons/CheckOutlined'
import InfoCircleTwoTone from '@ant-design/icons/InfoCircleTwoTone'
import { Button, message, Modal, Tooltip } from 'antd'
import React, { memo } from 'react'
import { EmptyText } from '../../../../../components/Common/CellText'
import utils from '../../../../../utils'
import {
  getSignChunkSizes,
  getSignRoundCount,
  MAIN_FILES_LIST_MAX_HEIGHT,
  SIGN_BATCH_SIZE_MAX,
} from '../canvasDocConstants'

const { confirm } = Modal

const MainFilesList = ({
  mainFiles,
  activeSignConfig,
  selectedFileToView,
  onSelectFile,
  onDirectSign,
  onBatchSignAll,
}) => {
  if (!mainFiles || mainFiles.length === 0) {
    return <EmptyText>Không có tài liệu trình ký</EmptyText>
  }

  const unsignedPdfCount = activeSignConfig
    ? mainFiles.filter(
        file =>
          !activeSignConfig.isSigned(file) &&
          utils.getExtensionFile(file.file_name) === 'pdf'
      ).length
    : 0

  const signLabel = activeSignConfig?.label || ''
  const signRoundCount = getSignRoundCount(unsignedPdfCount)
  const signChunkSizes = getSignChunkSizes(unsignedPdfCount)

  const handleSignClick = () => {
    confirm({
      title: 'Ký số tất cả',
      icon: <InfoCircleTwoTone />,
      content: (
        <div>
          <p style={{ marginBottom: signRoundCount > 1 ? 8 : 0 }}>
            Bạn có chắc chắn muốn ký số tất cả {unsignedPdfCount} file?
          </p>
          {signRoundCount > 1 && (
            <p style={{ marginBottom: 0 }}>
              Hệ thống chia {signRoundCount} lượt ký đều nhau . Vui lòng mở app
              VNPT SmartCA và xác nhận từng lượt — hệ thống gửi lượt tiếp theo
              sau khi lượt trước hoàn tất.
            </p>
          )}
        </div>
      ),
      okText: 'Đồng ý',
      okType: 'primary',
      cancelText: 'Hủy bỏ',
      onOk: () => onBatchSignAll(activeSignConfig),
    })
  }

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        gap: 12,
      }}>
      {activeSignConfig && unsignedPdfCount > 1 && (
        <Button
          type="primary"
          size="medium"
          onClick={handleSignClick}
          style={{ alignSelf: 'flex-end' }}>
          Ký số tất cả ({unsignedPdfCount})
        </Button>
      )}
      <div
        style={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          gap: 12,
          maxHeight: MAIN_FILES_LIST_MAX_HEIGHT,
          overflowY: 'auto',
          paddingRight: 4,
        }}>
        {mainFiles.map((file, index) => {
          const isSelected = selectedFileToView?.file_id === file.file_id
          const shouldDisable = activeSignConfig
            ? activeSignConfig.isSigned(file)
            : false

          return (
            <div
              key={file.file_id || index}
              onClick={() => onSelectFile(file)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 16px',
                width: '100%',
                background: isSelected ? '#e6f7ff' : '#fafafa',
                border: isSelected ? '2px solid #1890ff' : '1px solid #e8e8e8',
                borderRadius: 8,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: isSelected
                  ? '0 2px 8px rgba(24, 144, 255, 0.15)'
                  : '0 1px 3px rgba(0, 0, 0, 0.05)',
              }}
              onMouseEnter={e => {
                if (!isSelected) {
                  e.currentTarget.style.background = '#f0f0f0'
                  e.currentTarget.style.boxShadow =
                    '0 2px 8px rgba(0, 0, 0, 0.1)'
                  e.currentTarget.style.transform = 'translateY(-1px)'
                }
              }}
              onMouseLeave={e => {
                if (!isSelected) {
                  e.currentTarget.style.background = '#fafafa'
                  e.currentTarget.style.boxShadow =
                    '0 1px 3px rgba(0, 0, 0, 0.05)'
                  e.currentTarget.style.transform = 'translateY(0)'
                }
              }}>
              <div style={{ flex: 1 }}>
                <Tooltip title={file.file_name}>
                  <div
                    style={{
                      fontSize: 14,
                      fontWeight: isSelected ? 600 : 500,
                      color: isSelected ? '#1890ff' : '#262626',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: 200,
                      marginBottom: 4,
                    }}>
                    {file.file_name}
                  </div>
                </Tooltip>
              </div>

              {activeSignConfig && (
                <div
                  style={{ marginLeft: 12 }}
                  onClick={e => e.stopPropagation()}>
                  <Button
                    size="small"
                    type={shouldDisable ? 'default' : 'primary'}
                    icon={shouldDisable ? <CheckOutlined /> : null}
                    onClick={() => {
                      if (shouldDisable) {
                        message.info(
                          `File này đã ${signLabel.toLowerCase()} rồi!`
                        )
                        return
                      }
                      onDirectSign(file, index, activeSignConfig)
                    }}
                    disabled={shouldDisable}
                    style={{
                      borderRadius: 6,
                      fontWeight: 500,
                      boxShadow: shouldDisable
                        ? 'none'
                        : '0 2px 4px rgba(24, 144, 255, 0.2)',
                      cursor: shouldDisable ? 'not-allowed' : 'pointer',
                    }}>
                    {shouldDisable ? 'Đã ký' : signLabel}
                  </Button>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default memo(MainFilesList)
